export default "__VITE_ASSET__BCPGevj9__"